<h2 mat-dialog-title>Change Colour</h2>
<mat-dialog-content class="mat-typography">
  <h3>Which Color you like? </h3>
  <p>  
      <button class="w3-text-pink w3-pink" mat-button [mat-dialog-close]="'PINK'">P</button>
    <button class="w3-text-red w3-red" mat-button [mat-dialog-close]="'R'">R</button>
    <button class="w3-text-deep-orange w3-deep-orange" mat-button [mat-dialog-close]="'DO'">O</button>
    <button class="w3-text-orange w3-orange" mat-button [mat-dialog-close]="'O'">O</button>
    <button class="w3-text-yellow w3-yellow" mat-button [mat-dialog-close]="'Y'">_</button>
    <button class="w3-text-green w3-green" mat-button [mat-dialog-close]="'G'">G</button>
    <button class="w3-text-purple w3-purple" mat-button [mat-dialog-close]="'P'">P</button>
    <button class="w3-text-deep-purple w3-deep-purple" mat-button [mat-dialog-close]="'DP'">DP</button>
    <button class="w3-text-cyan w3-cyan" mat-button [mat-dialog-close]="'CY'">CY</button>
    <button class="w3-text-light-blue w3-light-blue" mat-button [mat-dialog-close]="'LB'">LB</button>
    <button class="w3-text-indigo w3-indigo" mat-button [mat-dialog-close]="'IND'">IND</button>
    <button class="w3-text-blue w3-blue" mat-button [mat-dialog-close]="'B'">B</button>  
    
    
    <button class="w3-text-black w3-black" mat-button [mat-dialog-close]="'BL'">B</button>
    <button class="w3-text-dark-grey w3-dark-grey" mat-button [mat-dialog-close]="'DG'">DG</button>
    
  
  
  
  </p>

 
</mat-dialog-content>
